const GenericComments = {
  InfoText: "GenericComments.InfoText",
  }
export default GenericComments;